import { BsCardText } from "react-icons/bs";
import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Text section",
  name: "textBox",
  type: "object",
  icon: BsCardText,
  fields: [
    {
      name: "sectionLayoutConfig",
      type: "sectionLayoutConfig",
      title: "Section Layout",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "heading",
      title: "Heading",
      type: "sectionTitle"
    },
    {
      name: "content",
      title: "Content",
      type: "multilingualArrayBlockContent"
    },
    {
      name: "boxed",
      title: "Is Boxed",
      type: "boolean"
    }
  ],
  preview: {
    select: {
      title: "heading.title",
      subtitle: "heading.tagline"
    },
    prepare({ title, subtitle }) {
      return {
        title: multilingualStringPreview(title),
        subtitle: multilingualStringPreview(subtitle)
      };
    }
  }
});
